import PropTypes from "prop-types";

export const VouchersIcon = ({ active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
      {...props}>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M16.386 11.213c0-1.15.933-2.083 2.083-2.083v-.833c0-3.334-.833-4.167-4.166-4.167H5.969c-3.333 0-4.166.833-4.166 4.167v.416a2.084 2.084 0 010 4.167v.416c0 3.334.833 4.167 4.166 4.167h8.334c3.333 0 4.166-.833 4.166-4.167a2.084 2.084 0 01-2.083-2.083zM7.637 13.089l5-5M12.633 13.088h.007M7.633 8.506h.007"></path>
    </svg>
  );
};

VouchersIcon.propTypes = {
  active: PropTypes.bool
};
